import Status from "components/base/Status";
import { Fragment } from "react";
import { BsArrowRight } from "react-icons/bs";

const PRODUCT_STATES = ["DRAFT", "TRIAL_ORDER", "MASS_PRODUCTION"];

const ProductStatusChainView = ({ state }) => {
  if (state === "ARCHIVED") return <Status status="ARCHIVED" />;

  return (
    <div className="flex items-center space-x-3">
      {PRODUCT_STATES.map((i, index) => (
        <Fragment key={index}>
          {index > 0 && (
            <BsArrowRight
              className={
                PRODUCT_STATES.indexOf(state) >= index ? "" : " opacity-30"
              }
            />
          )}
          <Status status={i} active={PRODUCT_STATES.indexOf(state) >= index} />
        </Fragment>
      ))}
    </div>
  );
};

export default ProductStatusChainView;
